import { cn } from '@/lib/utils'

interface ImagePlaceholderProps {
  className?: string
  text?: string
}

export function ImagePlaceholder({ className, text = 'Bez fotografie' }: ImagePlaceholderProps) {
  return (
    <div className={cn('flex items-center justify-center bg-slate-200', className)}>
      <div className="text-center text-slate-600">
        <svg className="mx-auto mb-2 h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <span className="text-sm">{text}</span>
      </div>
    </div>
  )
}
